import {Component, Inject, Input} from '@angular/core';
import {FieldValidationObj} from '../../../../../../../generated/generated-core.model';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {PrimitiveInputValue} from '../../services/mx-field-customizer.service';
import {MxField} from '../../services/mxField';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from "../../../../../../shared/services/mx-translate.service";

@Component({
    selector: 'mx-numeric-field',
    standalone: false,
    templateUrl: './mx-numeric-field.component.html'
})
export class MxNumericFieldComponent extends MxField {

    @Input()
    public validation: FieldValidationObj;
    @Input()
    public positiveInteger: boolean = false;

    constructor(public errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    getValue = (): PrimitiveInputValue => {
        let value: number = this.form.get([this.name]) && this.form.get([this.name]).value;
        if (this.fieldConfig && this.fieldConfig.displayFormat) {
            return this.fieldConfig.displayFormat(value);
        }
        if (typeof value === 'number') {
            return this.formatByFraction(value);
        } else {
            return value;
        }
    }

    private formatByFraction(value: number): PrimitiveInputValue {
        if (!this.validation || !this.validation.fractionDigits) {
            return value;
        }
        return value ? (+value).toFixed(this.validation.fractionDigits) : value;
    }

    public getDisplayValue(value: any): any {
        if (value && typeof value === 'number') {
            return this.formatByFraction(+value);
        } else {
            return super.getDisplayValue(value);
        }
    }
}
